import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptionBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReceiptionBell2"><Path d="M15 4.5H13.002V6.04688C15.322 6.27183 17.2409 7.28039 18.6201 8.82324C20.182 10.5705 21 12.9438 21 15.5V16.5H13L13.001 18H21V20H3V18H11.001L11 16.5H3V15.5C3 12.9438 3.818 10.5705 5.37988 8.82324C6.75988 7.27953 8.68017 6.27109 11.002 6.04688V4.5H9V2.5H15V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptionBell2;
